'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');let

DoNotDisturbNotificationSettingsDirective=function(_BaseControllerBacked){_inherits(DoNotDisturbNotificationSettingsDirective,_BaseControllerBacked);function DoNotDisturbNotificationSettingsDirective(){_classCallCheck(this,DoNotDisturbNotificationSettingsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DoNotDisturbNotificationSettingsDirective,[{key:'objectBindings',get:function()
{
return[
'emailAddress'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/doNotDisturbNotificationSettingsView';
}},{key:'controller',get:function()

{
return DoNotDisturbNotificationSettingsController;
}}]);return DoNotDisturbNotificationSettingsDirective}(BaseControllerBackedDirective);let


DoNotDisturbNotificationSettingsController=(_class=function(_BaseController){_inherits(DoNotDisturbNotificationSettingsController,_BaseController);_createClass(DoNotDisturbNotificationSettingsController,null,[{key:'$inject',get:function()
{
return['$timeout','$modal','$element','uncaughtErrorHandler','socketService','notificationService','uiCommandFactory'];
}}]);

function DoNotDisturbNotificationSettingsController($timeout,$modal,$element,uncaughtErrorHandler,socketService,notificationService,uiCommandFactory){_classCallCheck(this,DoNotDisturbNotificationSettingsController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this2._$timeout=$timeout;
_this2._$modal=$modal;
_this2._$element=$element;
_this2._socketService=socketService;
_this2._notificationService=notificationService;
_this2._uiCommandFactory=uiCommandFactory;

_this2._controllerInitialized=!1;
_this2._pendingDeletions={};

_this2.onForwardingEnabledChangeCommand=_this2._uiCommandFactory.make(_this2._onToggleForwardingEnabled.bind(_this2));

_this2._getNotificationSettings();return _this2;
}DoNotDisturbNotificationSettingsController.prototype.

addDoNotDisturbSchedule=function addDoNotDisturbSchedule(){var _this3=this;
let addDoNotDisturbScheduleModal=this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/addDoNotDisturbScheduleModalView',
controller:'AddDoNotDisturbScheduleModalController as controller',
windowClass:'add-schedule',
resolve:{
onScheduleAdded:function(){return _this3._handleErrorsAndRebuildViewModels.bind(_this3)}}});


};DoNotDisturbNotificationSettingsController.prototype.

editForwardingAddress=function editForwardingAddress(emailAddress){var _this4=this;
let addDoNotDisturbScheduleModal=this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/editForwardingAddressModalView',
controller:'EditForwardingAddressModalController as controller',
windowClass:'edit-forwarding-address',
resolve:{
emailAddress:function(){return emailAddress},
onAddressListUpdated:function(){return _this4._handleErrorsAndRebuildViewModels.bind(_this4)}}});


};DoNotDisturbNotificationSettingsController.prototype.

addForwardingAddress=function addForwardingAddress(){var _this5=this;
let addDoNotDisturbScheduleModal=this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/addForwardingAddressModalView',
controller:'AddForwardingAddressModalController as controller',
resolve:{
onAddressListUpdated:function(){return _this5._handleErrorsAndRebuildViewModels.bind(_this5)}}});


};DoNotDisturbNotificationSettingsController.prototype.


_getNotificationSettings=function(){var ref=_asyncToGenerator(function*(){
let notificationSettingsResponse=yield this._socketService.sendAndWaitForResponse('GetNotificationSettings');

yield this._handleErrorsAndRebuildViewModels(notificationSettingsResponse,!0);
});function _getNotificationSettings(){return ref.apply(this,arguments)}return _getNotificationSettings}();DoNotDisturbNotificationSettingsController.prototype.


_handleErrorsAndRebuildViewModels=function(){var ref=_asyncToGenerator(function*(notificationSettingsResponse){let isGettingNotificationSettings=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;
if(!SocketResponse.succeeded(notificationSettingsResponse)){
if(!isGettingNotificationSettings){
this._notificationService.displayNotification('An unexpected error occurred updating settings, please contact support.','error');
yield this._getNotificationSettings();
}else{
this._notificationService.displayNotification('Failed to retrieve notification settings.','error');
}
return;
}

this._makeViewModelsFromLatestSettings(notificationSettingsResponse.body);
});function _handleErrorsAndRebuildViewModels(notificationSettingsResponse){let isGettingNotificationSettings=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;return ref.apply(this,arguments)}return _handleErrorsAndRebuildViewModels}();DoNotDisturbNotificationSettingsController.prototype.

_makeViewModelsFromLatestSettings=function _makeViewModelsFromLatestSettings(notificationSettings){var _this6=this;
let oldSchedulesById=_.keyBy(this._doNotDisturbSchedules,'id');

notificationSettings.doNotDisturbSchedules.forEach(function(schedule){
let preExistingSchedule=oldSchedulesById[schedule.id];

schedule.togglePauseScheduleCommand=
_.exists(preExistingSchedule)?preExistingSchedule.togglePauseScheduleCommand:_this6._uiCommandFactory.make(_this6._onTogglePauseSchedule.bind(_this6));

schedule.deleteScheduleCommand=
_.exists(preExistingSchedule)?preExistingSchedule.deleteScheduleCommand:_this6._uiCommandFactory.make(_this6._onScheduleDeleted.bind(_this6));
});

for(let pendingDeletion of _(this._pendingDeletions).values().sortBy(function(pd){return pd.index}).value()){
notificationSettings.doNotDisturbSchedules.splice(pendingDeletion.index,0,pendingDeletion.schedule);
}

this._$timeout(function(){
_this6._doNotDisturbSchedules=notificationSettings.doNotDisturbSchedules;
_this6._forwardingEnabled=notificationSettings.forwardingEnabled;
_this6._forwardingAddressList=notificationSettings.forwardingAddressList;

_this6._controllerInitialized=!0;
});
};DoNotDisturbNotificationSettingsController.prototype.


_onToggleForwardingEnabled=function(){var ref=_asyncToGenerator(function*(newIsEnabledValue){
let notificationSettingsResponse=
yield this._socketService.sendAndWaitForResponse(newIsEnabledValue?'EnableNotificationForwarding':'DisableNotificationForwarding');

yield this._handleErrorsAndRebuildViewModels(notificationSettingsResponse);
});function _onToggleForwardingEnabled(newIsEnabledValue){return ref.apply(this,arguments)}return _onToggleForwardingEnabled}();DoNotDisturbNotificationSettingsController.prototype.


_onTogglePauseSchedule=function(){var ref=_asyncToGenerator(function*(scheduleViewModel){
let notificationSettingsResponse=
yield this._socketService.sendAndWaitForResponse(scheduleViewModel.isPaused?'UnpauseDoNotDisturbSchedule':'PauseDoNotDisturbSchedule',scheduleViewModel.id);

yield this._handleErrorsAndRebuildViewModels(notificationSettingsResponse);
});function _onTogglePauseSchedule(scheduleViewModel){return ref.apply(this,arguments)}return _onTogglePauseSchedule}();DoNotDisturbNotificationSettingsController.prototype.


_onScheduleDeleted=function(){var ref=_asyncToGenerator(function*(schedule){
let notificationSettingsResponse=yield this._socketService.sendAndWaitForResponse('DeleteDoNotDisturbSchedule',schedule.id);

this._addScheduleToPendingDeletions(schedule);

yield this._handleErrorsAndRebuildViewModels(notificationSettingsResponse);
});function _onScheduleDeleted(schedule){return ref.apply(this,arguments)}return _onScheduleDeleted}();DoNotDisturbNotificationSettingsController.prototype.

_addScheduleToPendingDeletions=function _addScheduleToPendingDeletions(schedule){var _this7=this;
schedule.deleted=!0;

this._pendingDeletions[schedule.id]={
timer:this._$timeout(function(){
let directiveElement=_this7._$element.find(`#${schedule.id}`).parent();
directiveElement.slideUp(382,function(){
_this7._$timeout(function(){
_.remove(_this7._doNotDisturbSchedules,_this7._pendingDeletions[schedule.id].schedule);
delete _this7._pendingDeletions[schedule.id];
});
});
},618),
schedule:schedule,
index:this._doNotDisturbSchedules.indexOf(schedule)};

};_createClass(DoNotDisturbNotificationSettingsController,[{key:'doNotDisturbSchedules',get:function()

{
return this._doNotDisturbSchedules;
}},{key:'forwardingEnabled',get:function()

{
return this._forwardingEnabled;
},set:function(

forwardingEnabled){
this._forwardingEnabled=forwardingEnabled;
}},{key:'forwardingAddressList',get:function()

{
return this._forwardingAddressList;
}}]);return DoNotDisturbNotificationSettingsController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_getNotificationSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_getNotificationSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_handleErrorsAndRebuildViewModels',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_handleErrorsAndRebuildViewModels'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onToggleForwardingEnabled',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onToggleForwardingEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onTogglePauseSchedule',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onTogglePauseSchedule'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onScheduleDeleted',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onScheduleDeleted'),_class.prototype)),_class);


module.exports=DoNotDisturbNotificationSettingsDirective;
module.exports.controller=DoNotDisturbNotificationSettingsController;
//# sourceMappingURL=doNotDisturbNotificationSettingsDirective.js.map
